import styled from "styled-components"

export const DatePickerContainer = styled.div`
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 55px;
  z-index: 10;

  .rdp-month {
    margin: 0;
  }

  .rdp-chevron {
    fill: ${(props) => props.theme.colors.text};
  }

  .rdp-month_grid {
    border-collapse: unset;
  }

  .rdp-day {
    background-color: #c3e3fd;
    border-radius: 6px;
    cursor: pointer;

    width: 36px;
    height: 36px;
  }

  .rdp-day_button {
    font-size: 1rem;

    width: 36px;
    height: 36px;
  }

  .rdp-day:not(.rdp-day_disabled):hover {
    background-color: #e0f0ff;
    border-radius: 6px;
    cursor: pointer;
  }

  .rdp-selected .rdp-day_button {
    border: none;
    background-color: ${(props) => props.theme.colors.primaryBlue};

    color: ${(props) => props.theme.colors.white};
    font-weight: normal;

    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .rdp-day_selected {
    background-color: #007bff;
    color: white;
  }

  .rdp-day_disabled {
    color: #ccc;
    cursor: not-allowed;
    text-decoration: line-through;
  }

  .rdp-today {
    color: ${(props) => props.theme.colors.primaryBlue};
  }
`

export const InputStyled = styled.input`
  width: 100%;
  background: #f8f8ff;
  height: 57px;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 16px;
  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  cursor: pointer;
`
